<div (window:resize)="findScreenSize()">
<div class="row liquid-heading">
    <div class="col-sm-12">
        <h5 class="rps-heading-five">Liquidity assets</h5>
    </div>
</div>
<div *ngIf="currentItems?.length && currentItems[0]?.effectiveDate; else noData">
    <div class="row liquid-subheading">
        <div class="col-md-12">
            <p class="rps-paragraph-two rps-grey" data-rpa-tag-id="liquidityAssetsSixMonths">for the past 6 months</p>
        </div>
    </div>
<div style="display: flex !important;">
    <form class="form-inline">
      <div class="form-group hidden">
          <div class="input-group">
              <input name="fromdatepicker" class="form-control" ngbDatepicker #fromdatepicker="ngbDatepicker" [markDisabled]="isDisabled" (dateSelect)="onFromDateSelection($event)" [displayMonths]="1" [dayTemplate]="t" outsideDays="hidden" [startDate]="fromDate!" tabindex="-1" [minDate]="maxFromDate"
                  [maxDate]="maxToDate" style="border:none;">
              <ng-template #t let-date let-focused="focused">
                  <span class="custom-day" [class.focused]="focused" (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null" style="width:100%">
                  {{ date.day }}
                  </span>
              </ng-template>
          </div>
      </div>
      <div class="form-group ">
          <div class="input-group">
              <input #dpFromDate class="form-control calendar-input" placeholder="mm/dd/yyyy" name="dpFromDate" [value]="parseDate(formatter.format(fromDate))" (input)="fromDate = validateInput(fromDate, dpFromDate.value)" disabled
              data-rpa-tag-id="liquidityAssetsFilterDate">
              <div class="input-group-append">
                  <button class="btn btn-outline-secondary calendar" (click)="fromdatepicker.toggle()" type="button">
          <div class="c11n-date-picker__box__icon"><svg class="c11n-date-picker-small" width="0.875rem" height="0.875rem"><use xlink:href="#date-picker-small"></use></svg>
          </div>
        </button>
              </div>
          </div>
      </div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

    </form>
      <form class="form-inline">
      <div class="form-group hidden">
          <div class="input-group  todtp">
              <input name="todatepicker" class="form-control" ngbDatepicker #todatepicker="ngbDatepicker" [markDisabled]="isDisabled" (dateSelect)="onToDateSelection($event)" [displayMonths]="1" [dayTemplate]="t" outsideDays="hidden" [startDate]="toDate!" tabindex="-1" [minDate]="maxFromDate"
                  [maxDate]="maxToDate" style="border:none;">
              <ng-template #t let-date let-focused="focused">
                  <span class="custom-day" [class.focused]="focused" (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null" style="width:100%">
                  {{ date.day }}
                  </span>
              </ng-template>
          </div>
      </div>
      <div class="form-group ">
          <div class="input-group">
              <input #dpToDate class="form-control calendar-input" placeholder="mm/dd/yyyy" name="dpToDate" [value]="parseDate(formatter.format(toDate))"
              (input)="toDate = validateInput(toDate, dpToDate.value)" disabled data-rpa-tag-id="liquidityAssetsFilterDate">
              <div class="input-group-append">
                  <button class="btn btn-outline-secondary calendar" (click)="todatepicker.toggle()" type="button">
          <div class="c11n-date-picker__box__icon" ><svg class="c11n-date-picker-small" width="0.875rem" height="0.875rem"><use xlink:href="#date-picker-small"></use></svg>
          </div>
        </button>
              </div>
          </div>
      </div>

    </form>
    </div>
    <div class="row relative-parent-for-scroll-buttons">
        <!-- <div class="col-sm-12 table-section"> -->
        <div class="horizontal-scroll-table">

        <table class="table table-hover">
        <thead>
            <tr>
                <th scope="col" style="text-align: left;" class="table-heading">Date</th>
                <th scope="col" style="text-align: right;">
                    <a role="button" tabindex="0" class="secYieldLink" (click)="dailyLiquidAssetsDialogContent.openModalDialog();" href="javascript:void(0)">
                    Daily liquid assets
                </a>

                <c11n-modal-dialog modalId="dailyLiquidModal" [headingText]="'Daily liquid assets'" #dailyLiquidAssetsDialogContent>
                    <div c11n-modal-dialog-body class="liquid-asset-gap">
                        <p class="vui-dialog-msg-box rps-paragraph-one" [innerHTML]="dailyLiquidAssets?.contentValue"></p>
                    </div>
                </c11n-modal-dialog>

                </th>
                <th scope="col" style="text-align: right;">
                    <a role="button" tabindex="0" class="secYieldLink" (click)="weeklyLiquidAssetsDialogContent.openModalDialog();" href="javascript:void(0)">
                    Weekly liquid assets
                </a>

                <c11n-modal-dialog modalId="weeklyLiquidModal" [headingText]="'Weekly liquid assets'" #weeklyLiquidAssetsDialogContent>
                    <div c11n-modal-dialog-body class="liquid-asset-gap">
                        <p class="vui-dialog-msg-box rps-paragraph-one" [innerHTML]="weeklyLiquidAssets?.contentValue"></p>
                    </div>
                </c11n-modal-dialog>

                </th>
                <th scope="col" style="text-align: right;">
                    <a role="button" tabindex="0" class="secYieldLink" (click)="dailyMarketValueDialogContent.openModalDialog();" href="javascript:void(0)">
                    Daily market value
                </a>

                <c11n-modal-dialog modalId="dailyMarketModal" [headingText]="'Daily market value'" #dailyMarketValueDialogContent>
                    <div c11n-modal-dialog-body class="liquid-asset-gap">
                        <p class="vui-dialog-msg-box rps-paragraph-one" [innerHTML]="dailyMarketValue?.contentValue"></p>
                    </div>
                </c11n-modal-dialog>

                </th>
                <th scope="col" style="text-align: right;">
                    <a role="button" tabindex="0" class="secYieldLink" (click)="dailyCashFlowDialogContent.openModalDialog();" href="javascript:void(0)">
                    Daily net shareholder cash flow
                </a>

                <c11n-modal-dialog modalId="dailyNetShareModal" [headingText]="'Daily net shareholder cash flow'" #dailyCashFlowDialogContent>
                    <div c11n-modal-dialog-body class="liquid-asset-gap">
                        <p class="vui-dialog-msg-box rps-paragraph-one" [innerHTML]="dailyNetShareholderCashFlow?.contentValue"></p>
                    </div>
                </c11n-modal-dialog>

                </th>
                <button class="right-btn" aria-label="Scroll Right" (click)="moveRight()" *ngIf="showRightButton && innerWidth<=576">
                  &RightAngleBracket;
              </button>
              <button class="left-btn" aria-label="Scroll Left" (click)="moveLeft()" *ngIf="scrollBarPosition>0 && innerWidth<=576">
                &LeftAngleBracket;
            </button>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of displayedItems">
                <td style="text-align: left;" data-rpa-tag-id="liquidityAssetsDate">{{item?.effectiveDate ? parseDate (item.effectiveDate) : '&mdash;'}}</td>
                <td style="text-align: right;" data-rpa-tag-id="dailyLiquidAssets">{{item?.dailyLiquidAsset ? item.dailyLiquidAsset+'%' : '&mdash;'}}</td>
                <td style="text-align: right;" data-rpa-tag-id="weeklyLiquidAssets">{{item?.weeklyLiquidAsset ? item.weeklyLiquidAsset+'%' : '&mdash;'}}</td>
                <td style="text-align: right;" data-rpa-tag-id="dailyMarketValue">{{item?.dailyMarketValue ? '$'+item.dailyMarketValue : '&mdash;'}}</td>
                <td style="text-align: right;" data-rpa-tag-id="dailyNetShareholderCashFlow">{{item?.dailyNetCashFlow ? (item.dailyNetCashFlow | currency) : '&mdash;'}}</td>
             </tr>
        </tbody>
    </table>
    </div>
    <div style="float:right;" class="col-sm-12 mt-2">
      <vmf-pagination class="select-value"  [paginationLabel]="'Liquidity Assets'" (newPageNumber)="getPageId($event)"  [listSize]="currentItems?.length"></vmf-pagination>
    </div>
    </div>
</div>
</div>
<ng-template #noData>
    <p class="no-data">This information is temporarily unavailable.</p>
</ng-template>
